import {Component} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {
  notFoundUrl: string = null;
  canGoBack = false;

  constructor(private location: Location,
              router: Router,
              private authenticationService: AuthenticationService) {
    const navigation = router.getCurrentNavigation() ?? router.lastSuccessfulNavigation;
    const state = navigation?.extras.state ?? this.location.getState() as any;
    const initialUrl = navigation?.initialUrl.toString();
    this.notFoundUrl = state?.notFoundUrl ?? (initialUrl && initialUrl !== '/404' ? initialUrl : null);
    this.canGoBack = state?.canGoBack ?? !!navigation?.previousNavigation;
  }

  goBack() {
    this.location.back();
  }

  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }
}
